import { getCustomisationFieldData, getGroupData, updateCustomisationValue } from '../EditablePreview/EditablePreview';
import DimensionsModule from './modules/dimensions/DimensionsModule';
import './Modules.scss';
import PositionModule from "./modules/position/PositionModule";
import AppearanceModule from './modules/appearance/AppearanceModule';
import BorderModule from './modules/border/BorderModule';
import FillModule from './modules/fill/FillModule';
import TypographyModule from './modules/typography/TypographyModule';
import PaddingModule from './modules/padding/PaddingModule';
import CopyModule from './modules/copy/CopyModule';
import AnimationModule from './modules/animation/AnimationModule';
import CustomModule from './modules/custom/CustomModule';
import { Fragment } from 'react';
import ShadowModule from './modules/shadow/ShadowModule';
import AudioModule from './modules/audio/AudioModule';

export const changeNumericalFieldValue = (customisationVars, fieldConfig, value, isInt = true, index = 0, forceComponentKey = null, node = null) => {
    if (fieldConfig?.dataLink) {
        const newValue = isInt ? parseInt(value, 10) : parseFloat(value);
        if (!isNaN(newValue)) {
            updateCustomisationValue(customisationVars, fieldConfig.dataLink, newValue, index, forceComponentKey, node);
            return true;
        }
    }
    console.warn(`Invalid value for field ${fieldConfig?.dataLink}: ${value}`);
    return false;
}

export const changeStringFieldValue = (customisationVars, fieldConfig, value, index = 0, forceComponentKey = null, node = null) => {
    if (fieldConfig?.dataLink) {
        updateCustomisationValue(customisationVars, fieldConfig.dataLink, value, index, forceComponentKey, node);
        return true;
    }
    console.warn(`Invalid value for field ${fieldConfig?.dataLink}: ${value}`);
    return false;
}

export const changeValue_noType = (customisationVars, fieldConfig, value, index = 0, forceComponentKey = null, node = null) => {
    if (fieldConfig?.dataLink) {
        updateCustomisationValue(customisationVars, fieldConfig.dataLink, value, index, forceComponentKey, node);
        return true;
    }
    console.warn(`Invalid value for field ${fieldConfig?.dataLink}: ${value}`);
    return false;
}

const ModuleList = (props) => {
    const { groupConfig, customisationVars } = props;
    const groupChildren = groupConfig?.children || [];
    const visualisationComponentKey = groupConfig?.visualisationConfig?.visualisationComponent !== '<Standard>' ? groupConfig?.visualisationConfig?.visualisationComponent : null;
    const activeNodeDataIndex = props.activeNode?.dataIndex ?? null;
    console.log("ModuleList: Looking for group data: ", props.campaignData, props.activeNode?.featureData?._id, groupConfig?.groupSettings?.dataLink);
    const groupSchema = getCustomisationFieldData(props.campaignData, props.activeNode?.featureData?._id, groupConfig?.groupSettings?.dataLink);
    console.log("ModuleList:", props, groupSchema);

    const nodesToList = [];
    let isListingMultiples = false;
    if (groupSchema?.allowMultiple && activeNodeDataIndex === null) {
        isListingMultiples = true;
        nodesToList.push(...props.activeNode.subNodes);
        nodesToList.pop();
    } else {
        nodesToList.push(props.activeNode);
    }

    if (isListingMultiples && nodesToList.length === 0) {
        return null;
    }

    const audioGroupDataLinkArray = props.activeTimelineAudioGroup ? props.activeTimelineAudioGroup?.audioData?.['audio-file']?.length ? props.activeTimelineAudioGroup.audioData['audio-file'].split('.') : null : null;
    const audioGroupDataLink = audioGroupDataLinkArray ? audioGroupDataLinkArray.slice(0, -1).join('.') : null;
    const audioCustomisationVars = props.activeTimelineAudioGroup ? getGroupData(customisationVars, audioGroupDataLink, -1) : null;

    return (
        <div className="v2-module-list">
            {audioCustomisationVars && audioCustomisationVars.map((audioNode, index) => {
                return (
                    <Fragment key={index}>
                        <div className="v2-basic-module-holder multiples-header">
                            <h5>{'Audio ' + (index + 1)}</h5>
                        </div>
                        <AudioModule
                            moduleConfig={props.activeTimelineAudioGroup?.audioData}
                            index={index}
                            visualisationComponentKey={visualisationComponentKey}
                            selectedFeatureNode={props.selectedFeatureNode}
                            customisationVars={customisationVars}
                            forceUpdate={props.forceUpdate}
                            forceUpdateComponent={props.forceUpdateComponent}
                            openTemporaryAudioUploadPopup={props.openTemporaryAudioUploadPopup}
                        />
                    </Fragment>
                );
            })}
            {nodesToList.length > 0 && nodesToList.map((node, index) => {
                const dataIndex = isListingMultiples ? (node.dataIndex ?? index) : (activeNodeDataIndex ?? 0);
                return (
                    <Fragment key={index}>
                        {isListingMultiples &&
                            <div className="v2-basic-module-holder multiples-header">
                                <h5>{props.activeNode.name + ' ' + (dataIndex + 1)}</h5>
                            </div>
                        }
                        {groupChildren.map((module, index) => {
                            if (module?.moduleSettings?.showInModuleList === false) {
                                // Skip modules that are not meant to be shown in the module list
                                return null;
                            }
                            if (module.type === 'module' && module.module === 'position') {
                                return (
                                    <PositionModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        customisationVars={customisationVars}
                                        forceUpdate={props.forceUpdate}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'dimensions') {
                                return (
                                    <DimensionsModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        customisationVars={customisationVars}
                                        forceUpdate={props.forceUpdate}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'appearance') {
                                return (
                                    <AppearanceModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        customisationVars={customisationVars}
                                        forceUpdate={props.forceUpdate}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'border') {
                                return (
                                    <BorderModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        customisationVars={customisationVars}
                                        forceUpdate={props.forceUpdate}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'fill') {
                                return (
                                    <FillModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        customisationVars={customisationVars}
                                        forceUpdate={props.forceUpdate}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                        openTemporaryImageUploadPopup={props.openTemporaryImageUploadPopup}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'typography') {
                                return (
                                    <TypographyModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        customisationVars={customisationVars}
                                        forceUpdate={props.forceUpdate}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                        openFontSelector={props.openFontSelector}
                                        openCustomFontSelector={props.openCustomFontSelector}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'padding') {
                                return (
                                    <PaddingModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        customisationVars={customisationVars}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'copy') {
                                return (
                                    <CopyModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        customisationVars={customisationVars}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'animation') {
                                return (
                                    <AnimationModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        customisationVars={customisationVars}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        campaignData={props.campaignData}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'shadow') {
                                return (
                                    <ShadowModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        customisationVars={customisationVars}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        campaignData={props.campaignData}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                        openFontSelector={props.openFontSelector}
                                        openCustomFontSelector={props.openCustomFontSelector}
                                        openTemporaryImageUploadPopup={props.openTemporaryImageUploadPopup}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'custom') {
                                return (
                                    <CustomModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        customisationVars={customisationVars}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        campaignData={props.campaignData}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                        openFontSelector={props.openFontSelector}
                                        openCustomFontSelector={props.openCustomFontSelector}
                                        openTemporaryImageUploadPopup={props.openTemporaryImageUploadPopup}
                                    />
                                );
                            }
                            if (module.type === 'module' && module.module === 'audio') {
                                return (
                                    <AudioModule
                                        key={index}
                                        moduleConfig={module}
                                        index={dataIndex}
                                        groupConfig={groupConfig}
                                        visualisationComponentKey={visualisationComponentKey}
                                        customisationVars={customisationVars}
                                        selectedFeatureNode={props.selectedFeatureNode}
                                        campaignData={props.campaignData}
                                        forceUpdateComponent={props.forceUpdateComponent}
                                        openFontSelector={props.openFontSelector}
                                        openCustomFontSelector={props.openCustomFontSelector}
                                        openTemporaryImageUploadPopup={props.openTemporaryImageUploadPopup}
                                        openTemporaryAudioUploadPopup={props.openTemporaryAudioUploadPopup}
                                    />
                                );
                            }
                            // Add other module types here as needed
                            return null;
                        })}
                    </Fragment>
                )
            })}
        </div>
    );
}

export default ModuleList;
